import GLightbox from 'glightbox'

const initBrandNewCarModelGlightBox = () => {
  GLightbox({
    selector: '.brand-new-car-model-glightbox'
  });
}

export default initBrandNewCarModelGlightBox;
